//@ts-nocheck

import React, { useContext } from 'react'
import * as S from './Checkbox.styles'

import { Paragraph } from '../../../atoms/Typography/Typography.component'
import { SpacerBase } from '../../../atoms/GridSystem'
import { useField } from 'formik'
import { SectionThemeContext } from '../../../../contexts/SectionTheme.context'

const Checkbox = ({ label, withBackground, ...props}) => {
  const { selectedColorScheme } = useContext(SectionThemeContext)
  const [ field, meta ] = useField({ ...props, type: 'checkbox' })
  const hasError = meta.touched && !!meta.error
  const errorId = `${props.name}-error`

  return (
    <>
      <S.Checkbox 
        colorScheme={selectedColorScheme}
        withBackground={withBackground}
        error={hasError && props.type !== 'hidden'}
      >
        <input
          {...field}
          {...props}
          id={props.id || props.name}
          type={'checkbox'}
          aria-invalid={hasError}
          aria-describedby={hasError ? errorId : undefined}
        />
        {label && props.type !== 'hidden' ? (
          <Paragraph typo={'paragraphXS'} as="label" htmlFor={props.id || props.name}>
            {label}
          </Paragraph>
        ) : null}
      </S.Checkbox>
      {hasError ? (
        <S.CheckboxError id={errorId} role="alert">
          <SpacerBase xs={1} />
          {meta.error}
        </S.CheckboxError>
      ) : null}
    </>
  )
}

export default Checkbox
